import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tw-min-h-screen tw-bg-slate-50" }
const _hoisted_2 = { class: "tw-mx-auto tw-w-full tw-max-w-7xl tw-px-4 tw-py-6 sm:tw-px-6 lg:tw-px-8" }
const _hoisted_3 = { class: "tw-flex tw-flex-col tw-gap-4 sm:tw-flex-row sm:tw-items-start sm:tw-justify-between" }
const _hoisted_4 = { class: "tw-min-w-0" }
const _hoisted_5 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_6 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "tw-mt-4 tw-rounded-xl tw-border tw-border-rose-200 tw-bg-rose-50 tw-px-4 tw-py-3 tw-text-sm tw-text-rose-900"
}
const _hoisted_9 = {
  key: 1,
  class: "tw-mt-6 tw-rounded-2xl tw-border tw-border-emerald-200 tw-bg-emerald-50 tw-p-5"
}
const _hoisted_10 = { class: "tw-flex tw-flex-col tw-gap-2 sm:tw-flex-row sm:tw-items-center sm:tw-justify-between" }
const _hoisted_11 = { class: "tw-text-sm tw-font-semibold tw-text-emerald-900" }
const _hoisted_12 = { class: "tw-mt-1 tw-text-sm tw-text-emerald-900/90" }
const _hoisted_13 = { class: "tw-text-sm tw-text-emerald-900/90" }
const _hoisted_14 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_15 = { class: "tw-mt-4 tw-overflow-x-auto" }
const _hoisted_16 = { class: "tw-min-w-full tw-text-left tw-text-sm" }
const _hoisted_17 = { class: "tw-divide-y tw-divide-emerald-200/60" }
const _hoisted_18 = { class: "tw-px-3 tw-py-2" }
const _hoisted_19 = { class: "tw-px-3 tw-py-2" }
const _hoisted_20 = { class: "tw-px-3 tw-py-2" }
const _hoisted_21 = { class: "tw-mt-6 tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-900/5" }
const _hoisted_22 = { class: "tw-border-b tw-border-slate-200/70 tw-px-5 tw-py-4" }
const _hoisted_23 = { class: "tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3" }
const _hoisted_24 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_25 = {
  key: 0,
  class: "tw-flex tw-items-center tw-gap-2"
}
const _hoisted_26 = {
  key: 1,
  class: "tw-flex tw-items-center tw-gap-2"
}
const _hoisted_27 = { class: "tw-p-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NewOrderForm = _resolveComponent("NewOrderForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-text-slate-700 hover:tw-bg-slate-50",
              "aria-label": "Back to orders",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "arrow-left",
                class: "tw-h-4 tw-w-4"
              })
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "tw-pl-1" }, [
              _createElementVNode("h1", { class: "tw-text-left tw-text-lg tw-font-semibold tw-text-slate-900" }, "New Order"),
              _createElementVNode("p", { class: "tw-mt-1 tw-text-left tw-text-sm tw-text-slate-600" }, "Create an order and add containers/loads.")
            ], -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 hover:tw-bg-slate-50",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, " Cancel "),
          _createElementVNode("button", {
            type: "button",
            class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-slate-800",
            disabled: _ctx.loading,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addNewOrder && _ctx.addNewOrder(...args)))
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  icon: "circle-notch",
                  spin: "",
                  class: "tw-mr-2 tw-h-4 tw-w-4"
                }))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.orderCreationButtonText), 1)
          ], 8, _hoisted_7)
        ])
      ]),
      (_ctx.submissionError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.submissionError), 1))
        : _createCommentVNode("", true),
      (_ctx.createdOrder)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_11, "Created Order #" + _toDisplayString(_ctx.createdOrder.id), 1),
                _createElementVNode("div", _hoisted_12, [
                  _cache[12] || (_cache[12] = _createElementVNode("span", { class: "tw-font-medium" }, "Drop-Off:", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.createdOrder.receiver?.name || '—'), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "tw-font-medium" }, "Bill To:", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.createdOrder.billTo?.name || '—'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_router_link, {
                  class: "tw-inline-flex tw-items-center tw-rounded-lg tw-bg-emerald-700 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-emerald-800",
                  to: `/orders/${_ctx.createdOrder.id}`
                }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode(" View Order ", -1)
                  ]))]),
                  _: 1
                }, 8, ["to"]),
                _createElementVNode("button", {
                  type: "button",
                  class: "tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-emerald-300 tw-bg-white/60 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-emerald-900 hover:tw-bg-white",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetAfterCreate && _ctx.resetAfterCreate(...args)))
                }, " Create Another ")
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("table", _hoisted_16, [
                _cache[15] || (_cache[15] = _createElementVNode("thead", { class: "tw-text-xs tw-uppercase tw-tracking-wide tw-text-emerald-900/70" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Container"),
                    _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Size/Type"),
                    _createElementVNode("th", { class: "tw-px-3 tw-py-2" }, "Terminal")
                  ])
                ], -1)),
                _createElementVNode("tbody", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.createdOrder.containers || [], (c, idx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: `created-container-${idx}`
                    }, [
                      _createElementVNode("td", _hoisted_18, _toDisplayString(c.containerId && c.containerId !== 'EXPUNDEF' ? c.containerId : 'Container undefined'), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(c.sizeType), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(c.terminal), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.isOceanOrder ? 'tw-border-transparent tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-white tw-text-slate-700 hover:tw-bg-slate-50']),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setOrderType(_ctx.ORDER_TYPE.OCEAN_IMPORT)))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "ship",
                  class: "tw-h-4 tw-w-4"
                }),
                _cache[16] || (_cache[16] = _createElementVNode("span", null, "Ocean", -1))
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.isRailOrder ? 'tw-border-transparent tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-white tw-text-slate-700 hover:tw-bg-slate-50']),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setOrderType(_ctx.ORDER_TYPE.RAIL_PICK_UP)))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "train",
                  class: "tw-h-4 tw-w-4"
                }),
                _cache[17] || (_cache[17] = _createElementVNode("span", null, "Rail", -1))
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.isLandOrder ? 'tw-border-transparent tw-bg-slate-900 tw-text-white' : 'tw-border-slate-200 tw-bg-white tw-text-slate-700 hover:tw-bg-slate-50']),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setOrderType(_ctx.ORDER_TYPE.LAND)))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "truck",
                  class: "tw-h-4 tw-w-4"
                }),
                _cache[18] || (_cache[18] = _createElementVNode("span", null, "Land", -1))
              ], 2)
            ]),
            (_ctx.isOceanOrder)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.isImportOrder ? 'tw-border-transparent tw-bg-indigo-600 tw-text-white' : 'tw-border-slate-200 tw-bg-white tw-text-slate-700 hover:tw-bg-slate-50']),
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setOrderType(_ctx.ORDER_TYPE.OCEAN_IMPORT)))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "arrow-down",
                      class: "tw-mr-2 tw-h-4 tw-w-4"
                    }),
                    _cache[19] || (_cache[19] = _createTextVNode(" Import ", -1))
                  ], 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.isOceanExport ? 'tw-border-transparent tw-bg-indigo-600 tw-text-white' : 'tw-border-slate-200 tw-bg-white tw-text-slate-700 hover:tw-bg-slate-50']),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setOrderType(_ctx.ORDER_TYPE.OCEAN_EXPORT)))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "arrow-up",
                      class: "tw-mr-2 tw-h-4 tw-w-4"
                    }),
                    _cache[20] || (_cache[20] = _createTextVNode(" Export ", -1))
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isRailOrder)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.isRailPickUp ? 'tw-border-transparent tw-bg-indigo-600 tw-text-white' : 'tw-border-slate-200 tw-bg-white tw-text-slate-700 hover:tw-bg-slate-50']),
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setOrderType(_ctx.ORDER_TYPE.RAIL_PICK_UP)))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "arrow-left",
                      class: "tw-mr-2 tw-h-4 tw-w-4"
                    }),
                    _cache[21] || (_cache[21] = _createTextVNode(" Rail Pick-Up ", -1))
                  ], 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-transition", _ctx.isRailDropOff ? 'tw-border-transparent tw-bg-indigo-600 tw-text-white' : 'tw-border-slate-200 tw-bg-white tw-text-slate-700 hover:tw-bg-slate-50']),
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setOrderType(_ctx.ORDER_TYPE.RAIL_DELIVERY)))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "arrow-right",
                      class: "tw-mr-2 tw-h-4 tw-w-4"
                    }),
                    _cache[22] || (_cache[22] = _createTextVNode(" Rail Delivery ", -1))
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_NewOrderForm, {
            onOnBillingCustomerSearch: _ctx.onBillingCustomerSearch,
            onOnReceivingCustomerSearch: _ctx.onReceivingCustomerSearch,
            onOnBLSearch: _ctx.onBLSearch,
            billingCustomers: _ctx.billingCustomers || [],
            receivingCustomers: _ctx.receivingCustomers || [],
            activeBLs: _ctx.activeBLs || [],
            blStatus: _ctx.blStatus,
            terminals: _ctx.terminals || [],
            orderData: _ctx.orderData,
            orderType: _ctx.orderData.orderType,
            fieldErrors: _ctx.fieldErrors,
            settingsOrderShowLinkedOrderNumberField: !!(_ctx.company && _ctx.company.settingsOrderShowLinkedOrderNumberField),
            showVesselInformation: !!(_ctx.company && _ctx.company.settingsOrderShowVesselInformation),
            settingsOrderShowEmergencyInformation: !!(_ctx.company && _ctx.company.settingsOrderShowEmergencyInformation),
            settingsOrderLtlEnabled: !!(_ctx.company && _ctx.company.settingsOrderLtlEnabled),
            showBrokerFields: !!(_ctx.company && _ctx.company.isBroker)
          }, null, 8, ["onOnBillingCustomerSearch", "onOnReceivingCustomerSearch", "onOnBLSearch", "billingCustomers", "receivingCustomers", "activeBLs", "blStatus", "terminals", "orderData", "orderType", "fieldErrors", "settingsOrderShowLinkedOrderNumberField", "showVesselInformation", "settingsOrderShowEmergencyInformation", "settingsOrderLtlEnabled", "showBrokerFields"])
        ])
      ])
    ])
  ]))
}